<div class="modal-header">
    <h4 class="modal-title">Confirmation</h4>
</div>
<div class="modal-body">
    <p>{{text}}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
        <i class="fa fa-times"></i> No
    </button>
    <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">
        <i class="fa fa-check-square"></i> Yes
    </button>
</div>
